<template>
  <div>
    <tabs id="tabs-form" ref="tabs">
      <tab-pane id="tab-general" title="general" active>
        <b-icon
          slot="title"
          icon="gear"
          v-b-tooltip.hover.top="'General settings'"
          scale="1.1"
          aria-hidden="true"
        />

        <b-form-group
          id="input-group-name"
          :label="$t('device_groups.name')"
          :label-for="'input-name'"
        >
          <b-form-input
            id="input-name"
            v-model="form.name"
            :disabled="disabledFields"
            required
          />
        </b-form-group>

        <b-form-group
          id="input-group-description"
          :label="$t('device_groups.description')"
          :label-for="'textarea-description'"
        >
          <b-form-textarea
            id="textarea-description"
            v-model="form.description"
            :disabled="disabledFields"
          ></b-form-textarea>
        </b-form-group>

        <b-row>
           
        <b-col cols=4>
        <b-form-group
          id="input-group-color"
          :label="$t('device_groups.color')"
          :label-for="'input-color'"
        >

        <b-input-group id='input-color'>
          <b-form-input
            v-model="form.color"
            :disabled="disabledFields"
            @click='toggleColorPicker()'
            :style="getBackgroundColor()"
            readonly
           
          />
          
           <b-input-group-append>
            <b-input-group-text @click='toggleColorPicker()'>
                <b-icon v-if='!showColorPicker' icon="chevron-down" />
                 <b-icon v-else icon="chevron-up" />
            </b-input-group-text>
          </b-input-group-append>

           </b-input-group>


        </b-form-group>
        </b-col>
 
        </b-row>

        <div id='color-picker' v-if='showColorPicker'>
            <swatches-picker v-model="selectedColor" @input="colorChanged"/>
        </div>
    </tab-pane>
      
      
      <tab-pane id="tab-group-members" title="devices" v-if="action == 'edit'">
        <b-icon
          slot="title"
          icon="display"
          v-b-tooltip.hover.top="$t('device_groups.devices_in_group')"
          scale="1.1"
        />

        <DeviceSelectForm
          :devices="form.devices"
          v-on:updateDevices="updateDevices"
          deviceType = "INFOPOINT"
        ></DeviceSelectForm>
      </tab-pane>
    </tabs>

   
    <b-modal id='color-modal' :title="$t('deviation_settings.choose_color')" class="color-modal" hide-footer >
      <swatches-picker v-model="selectedColor" @input="colorChanged"/>
    </b-modal>


    <t-button-group>
      <t-button type="save" @click="save" :disabled="disabledFields"></t-button> 
      <t-button v-if="action == 'edit'" type="rm" @click="deleteModal" :disabled="disabledFields" right></t-button> 
    </t-button-group>

    <DeleteModal :itemid="form.name" @ok="remove" />

    <RequestInfo
      :type="infoType"
      :ok="!error && showRequestResult"
      :error="error && showRequestResult"
      :loader="loading"
      :additionalErrorMsg="responseError"
    />
</div>
 
</template>

<script>
import DeviceSelectForm from '@/components/Devices/Device/DeviceSelectForm'
import { Swatches } from 'vue-color'

export default {
  components: {
    DeviceSelectForm,
    'swatches-picker': Swatches
  },
  props: {
    item: { default: null },
    action: { default: 'new' },
    newItemEvent:  { default: 0 }
  },
  data() {
    return {
      form: {
        id: null,
        name: "",
        description: "",
        color: "#000000",
        devices: []
      },

      itemName: '', // original item.name
      showRequestResult: false,
      error: false,
      loading: false,
      infoType: 'save',
      disabledFields: false,
      responseError: null,
      selectedColor: "",
      showColorPicker: false
    }
  },
  created() {
     this.initForm();
  },
  computed: {
    isValidForm() {
      if (this.item?.name) return this.item.name.length > 0
      else return false
    }
  },
  watch: {
    action(){
      //console.log('action: ' + this.action);
    },
    item() {
      //console.log("item change: " + this.item);
      this.showRequestResult = false
      this.error = false
      this.loading = false
      this.disabledFields = false
      this.infoType = 'save'

      this.initForm();

      this.selectedColor = this.form.color;
    },
    newItemEvent(){
      //console.log("newItemEvent: " + this.newItemEvent);
      this.resetForm();
    },
  },
  methods: {
    resetForm(){
      this.form = { id: null, name: "", description: "", color: "#000000", devices: [] };
      this.showRequestResult = false
      this.error = false
      this.loading = false
      this.disabledFields = false
      this.infoType = 'save'
      this.$refs.tabs.findAndActivateTab("general");
    },
    initForm(){
      if(this.item) {
        // this for update 
        this.$nextTick(function () {
            this.form = JSON.parse(JSON.stringify(this.item));
        });
        
      } else {
        this.form = { id: null, name: "", description: "", color: "#000000", devices: [] };
      }
    },

    toggleColorPicker(){
      this.showColorPicker = !this.showColorPicker;
    },
    colorChanged(){
      this.form.color = this.selectedColor.hex;
      this.showColorPicker = false;
    },
    getBackgroundColor(){
      return "background-color: " + this.form.color; 
    },
    updateAndEmitItemName(newItemName) {
      this.itemName = newItemName
      this.$emit('itemName', this.itemName)
    },
    updateDevices(newDevices) {
      this.form.devices = newDevices
    },
    save() {
      this.disabledFields = true;
      this.responseError = null
      this.error = false
      this.infoType = 'save'
      this.loading = true


      if (this.action === 'new') {
        this.$store
          .dispatch('deviceGroup/addDeviceGroup', this.form)
          .then((response) => {
            const responseCodeHeader = response.status
            if (responseCodeHeader >= 200 && responseCodeHeader < 300) {
              this.error = false
            } else {
              this.error = true
            }
          })
          .catch((error) => {
            if (error?.response) {
              const statusCode = error.response?.status
              const errorMsg = error.response?.data?.message
              if (statusCode === 409) {
                this.responseError = this.$t(
                  'response.object_name_already_exists'
                )
                console.error(errorMsg)
              } else if (statusCode === 400) {
                this.responseError = this.$t('response.invalid_entity')
                console.error(errorMsg)
              } else {
                this.responseError = statusCode
                console.error(errorMsg)
              }
            } else {
              this.responseError = this.$t('response.server_error')
            }
            this.error = true
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.showRequestResult = true;
            }, 300)
          })
      } else if (this.action === 'edit') {
        this.$store
          .dispatch('deviceGroup/updateDeviceGroup', this.form)
          .then((response) => {
            const responseCodeHeader = response.status
            if (responseCodeHeader >= 200 && responseCodeHeader < 300) {
              this.error = false
              this.updateAndEmitItemName(this.form.name)
            } else {
              this.error = true
            }
          })
          .catch((error) => {
            if (error?.response) {
              const statusCode = error.response?.status
              const errorMsg = error.response?.data?.message
              if (statusCode === 404) {
                this.responseError = this.$t('response.no_object_id')
                console.error(errorMsg)
              } else if (statusCode === 409) {
                this.responseError = this.$t('response.conflict')
                console.error(errorMsg)
              } else if (statusCode === 400) {
                this.responseError = this.$t('response.invalid_entity')
                console.error(errorMsg)
              } else {
                this.responseError = statusCode
                console.error(errorMsg)
              }
            } else {
              this.responseError = this.$t('response.server_error')
            }
            this.error = true
          })
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
              this.showRequestResult = true; 
            }, 300)
          })
      }
    },
    deleteModal(){
      this.$bvModal.show('delete-modal')
    },
    remove() {
      this.error = false
      this.infoType = 'delete'
      this.loading = true

      this.$store
        .dispatch('deviceGroup/removeDeviceGroup', this.form.id)
        .then((response) => {
          const responseCodeHeader = response.status
          if (responseCodeHeader >= 200 && responseCodeHeader < 300) {
            this.error = false
          } else {
            this.error = true
          }
        })
        .catch((error) => {
          if (error?.response) {
            const statusCode = error.response?.status
            const errorMsg = error.response?.data?.message
            if (statusCode === 404) {
              this.responseError = this.$t('response.no_object_id')
              console.error(errorMsg)
            } else {
              this.responseError = statusCode
              console.error(errorMsg)
            }
          } else {
            this.responseError = this.$t('response.server_error')
          }
          this.error = true
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
            this.showRequestResult = true;
          }, 300)
        })

      
      /*
      this.form.name = "";
      this.form.description = "";
      this.form.devices = [];
      */
      this.disabledFields = true;
    },
  },
}
</script>

<style lang="scss">
#color-modal {
  .modal-body {
    height: 370px;
  }

  .vc-swatches{
    height: 100%;
    width: 100%;
    overflow-y: auto;
  }
}

#color-picker {
    margin-bottom: 10px;

    .vc-swatches {
      width: 100%;
      height: 100%;
      overflow-y: auto;
    }
}

#input-color {
  input{
    text-align: center;
    color: white;
    cursor: pointer;
  }

  .input-group-text {
    background-color: #f5f5f5; 
    .b-icon {
      margin-left: 8px;
      cursor: pointer;
    }
  }

}
 

</style>
